import React, { Component } from "react";


import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Icon from "@mui/material/Icon"
import Grid from "@mui/material/Grid";
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import styles from "./index.module.css";
import * as ajax from "helpers/ajax";
import { PATH, UPLOAD_PATH } from "../../constant";

import { DropzoneDialog } from 'material-ui-dropzone';
import CircularProgress from '@mui/material/CircularProgress';



class FileSystem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            path: [this.props.baseRoute + "/" + this.props.id+this.props.subfolder],
            files: {},
            contextMenuVisible: false,
            contextMenuAnchor: null,
            contextFileSelected: false,
            modalUploadOpen: false,
            loading:true,
            error: null,
            hasError500: false,
            selectedFiles: [], // Array di file/cartelle selezionati
            lastSelectedIndex: null, // Per gestire shift+click
            isDragging: false, // Drag selection attivo
            dragStart: null, // Coordinate inizio drag { x, y }
            dragEnd: null, // Coordinate correnti drag { x, y }
            dragMoved: false, // Traccia se il mouse si è mosso durante il drag
            searchQuery: '', // Termine di ricerca per filtrare file/cartelle
            searchResults: null, // Risultati della ricerca ricorsiva
            isSearching: false, // Indica se una ricerca è in corso
        };
        this.containerRef = React.createRef();
        this.fileRefs = {}; // Map di riferimenti agli elementi file/folder
        this.folderInputRef = React.createRef(); // Ref per input caricamento cartelle
        this.filesToDeleteCache = []; // Cache per i file da eliminare (per evitare problemi con state reset)
        this.searchTimeout = null; // Timeout per debounce della ricerca
    }

    componentDidMount = () => {
        this.downloadFiles()
    }

    downloadFiles = () => {
        let formData = new FormData();
        formData.append("path", this.state.path.join("/"))
        
        // Aggiungi gestione degli errori per il file system
        try {
            ajax.ajaxPost("/file_list.php", formData, this.downloadFilesCallback, this.downloadFilesErrorCallback)
        } catch (error) {
            console.error("Errore nel caricamento file system:", error);
            this.setState({ 
                files: { directory: [], files: [] }, 
                loading: false,
                error: "File system non disponibile" 
            });
        }
    }

    downloadFilesCallback = (response) => {
        if (response && response.message) {
            this.setState({ 
                files: response.message, 
                loading: false, 
                error: null,
                selectedFiles: [], // Reset selezione quando cambia directory
                searchResults: null // Reset risultati ricerca
            })
        } else {
            this.setState({ 
                files: { directory: [], files: [] }, 
                loading: false,
                error: "Risposta non valida dal server" 
            })
        }
    }

    searchFiles = (query) => {
        if (!query || query.trim().length === 0) {
            this.setState({ searchResults: null, isSearching: false });
            return;
        }

        this.setState({ isSearching: true });

        let formData = new FormData();
        formData.append("path", this.state.path.join("/"));
        formData.append("search", query);

        ajax.ajaxPost("/file_search.php", formData, 
            (response) => {
                if (response && response.message) {
                    this.setState({ 
                        searchResults: response.message.results,
                        isSearching: false
                    });
                } else {
                    this.setState({ 
                        searchResults: [],
                        isSearching: false
                    });
                }
            },
            (error) => {
                console.error("Errore ricerca:", error);
                this.setState({ 
                    searchResults: [],
                    isSearching: false
                });
            }
        );
    }

    handleSearchChange = (value) => {
        this.setState({ searchQuery: value });

        // Debounce della ricerca
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        if (value.trim().length === 0) {
            this.setState({ searchResults: null, isSearching: false });
            return;
        }

        this.searchTimeout = setTimeout(() => {
            this.searchFiles(value);
        }, 500);
    }

    downloadFilesErrorCallback = (error) => {
        // AxiosError ha lo status in error.response.status
        const statusCode = error?.response?.status || error?.status || error?.statusCode;
        
        if (statusCode === 500) {
            this.setState({ 
                files: { directory: [], files: [] }, 
                loading: false,
                error: "Directory non trovata",
                hasError500: true
            });
        } else {
            this.setState({ 
                files: { directory: [], files: [] }, 
                loading: false,
                error: "Servizio file system temporaneamente non disponibile",
                hasError500: false
            });
        }
    }

    goBack = (index) => {
        if (index == this.state.path.length - 1) { return }
        let path = this.state.path.slice(0, index + 1);
        this.setState({ path: path, selectedFiles: [] }, this.downloadFiles)
    }

    openFolder = (file) => {
        let path = this.state.path;
        path.push(file)
        this.setState({ path: path, selectedFiles: [] }, this.downloadFiles)
    }

    handleFileClick = (fileName, index, event, isFolder = false) => {
        event.stopPropagation(); // Previeni che il click si propaghi al container
        
        // Previeni doppio click se non è double click
        if (event.detail === 2) {
            // Doppio click - apri file/cartella
            if (isFolder) {
                this.openFolder(fileName);
            } else {
                this.openFile(fileName);
            }
            return;
        }

        // Single click con modificatori
        const allItems = [...(this.state.files.directory || []), ...(this.state.files.files || [])];
        
        if (event.ctrlKey || event.metaKey) {
            // Ctrl+click: aggiungi/rimuovi dalla selezione
            if (this.state.selectedFiles.includes(fileName)) {
                this.setState({
                    selectedFiles: this.state.selectedFiles.filter(f => f !== fileName),
                    lastSelectedIndex: index
                });
            } else {
                this.setState({
                    selectedFiles: [...this.state.selectedFiles, fileName],
                    lastSelectedIndex: index
                });
            }
        } else if (event.shiftKey && this.state.lastSelectedIndex !== null) {
            // Shift+click: seleziona range
            const start = Math.min(this.state.lastSelectedIndex, index);
            const end = Math.max(this.state.lastSelectedIndex, index);
            const rangeFiles = allItems.slice(start, end + 1);
            
            this.setState({
                selectedFiles: [...new Set([...this.state.selectedFiles, ...rangeFiles])],
                lastSelectedIndex: index
            });
        } else {
            // Click normale: seleziona solo questo
            this.setState({
                selectedFiles: [fileName],
                lastSelectedIndex: index
            });
        }
    }

    isSelected = (fileName) => {
        return this.state.selectedFiles.includes(fileName);
    }

    handleContainerMouseDown = (event) => {
        // NON iniziare drag con tasto destro (context menu)
        if (event.button !== 0) {
            return;
        }
        
        // NON iniziare drag se clicco su un file/cartella (hanno classe folder)
        if (event.target.closest('.'+styles.folder)) {
            return; // Lascia che handleFileClick gestisca l'evento
        }
        
        // Solo se click su sfondo
        if (event.target === event.currentTarget || !event.target.closest('.'+styles.folder)) {
            // Previeni selezione testo durante drag
            event.preventDefault();
            
            const rect = this.containerRef.current.getBoundingClientRect();
            const startPos = {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top
            };
            
            this.setState({
                isDragging: true,
                dragStart: startPos,
                dragEnd: startPos,
                dragMoved: false
            });
        }
    }

    handleContainerMouseMove = (event) => {
        if (!this.state.isDragging) return;

        const rect = this.containerRef.current.getBoundingClientRect();
        const dragEnd = {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top
        };

        // Controlla se il mouse si è spostato di almeno 3px (per distinguere click da drag)
        const moved = Math.abs(dragEnd.x - this.state.dragStart.x) > 3 || 
                      Math.abs(dragEnd.y - this.state.dragStart.y) > 3;

        this.setState({ dragEnd, dragMoved: moved });

        // Calcola file nel rettangolo di selezione solo se si è mosso
        if (moved) {
            this.updateDragSelection();
        }
    }

    handleContainerMouseUp = () => {
        if (this.state.isDragging) {
            // Se non c'è stato movimento, è un click puro → deseleziona tutto
            if (!this.state.dragMoved) {
                this.setState({ selectedFiles: [] });
            }
            
            this.setState({
                isDragging: false,
                dragStart: null,
                dragEnd: null,
                dragMoved: false
            });
        }
    }

    updateDragSelection = () => {
        if (!this.state.dragStart || !this.state.dragEnd) return;

        const containerRect = this.containerRef.current.getBoundingClientRect();
        const selectionRect = this.getSelectionRect();

        const selectedFiles = [];
        const allItems = [...(this.state.files.directory || []), ...(this.state.files.files || [])];

        allItems.forEach(fileName => {
            const fileRef = this.fileRefs[fileName];
            if (fileRef) {
                const fileRect = fileRef.getBoundingClientRect();
                // Converti a coordinate relative al container
                const relativeFileRect = {
                    left: fileRect.left - containerRect.left,
                    top: fileRect.top - containerRect.top,
                    right: fileRect.right - containerRect.left,
                    bottom: fileRect.bottom - containerRect.top
                };

                // Controlla intersezione
                if (this.rectsIntersect(selectionRect, relativeFileRect)) {
                    selectedFiles.push(fileName);
                }
            }
        });

        this.setState({ selectedFiles });
    }

    getSelectionRect = () => {
        const { dragStart, dragEnd } = this.state;
        return {
            left: Math.min(dragStart.x, dragEnd.x),
            top: Math.min(dragStart.y, dragEnd.y),
            right: Math.max(dragStart.x, dragEnd.x),
            bottom: Math.max(dragStart.y, dragEnd.y)
        };
    }

    rectsIntersect = (rect1, rect2) => {
        return !(
            rect1.right < rect2.left ||
            rect1.left > rect2.right ||
            rect1.bottom < rect2.top ||
            rect1.top > rect2.bottom
        );
    }

    openFile = (file) => {
        window.open(
            UPLOAD_PATH + "/file" + this.state.path.join("/") + "/" + file,
            '_blank' // <- This is what makes it open in a new window.
        );
    }

    openContextMenu = (event, file = null) => {

        event.preventDefault();
        event.stopPropagation();

        if (this.state.contextMenuVisible) {
            this.closeContextMenu();
            return;
        }

        // Se c'è un file e non è selezionato, seleziona solo quello
        // MA se ci sono già file selezionati e faccio tasto destro su uno di essi, mantieni la selezione
        if (file) {
            if (!this.state.selectedFiles.includes(file)) {
                // File non nella selezione corrente -> seleziona solo questo
                this.setState({ selectedFiles: [file] });
                this.filesToDeleteCache = [file];
            } else {
                // Salva la selezione corrente nella cache
                this.filesToDeleteCache = [...this.state.selectedFiles];
            }
        } else {
            // Context menu su sfondo
            this.filesToDeleteCache = [];
        }

        let contextAnchor = {
            left: event.clientX + 2,
            top: event.clientY - 6,
        }

        this.setState({ contextMenuVisible: true, contextMenuAnchor: contextAnchor, contextFileSelected: file ? file : false })
    }

    closeContextMenu = () => {
        this.setState({ contextMenuVisible: false, contextFileSelected:false })
    }

    deleteFile = (filesToDelete) => {
        this.closeContextMenu()
        
        const confirmMessage = filesToDelete.length > 1 
            ? `Sei sicuro di voler eliminare ${filesToDelete.length} elementi?`
            : `Sei sicuro di voler eliminare "${filesToDelete[0]}"?`;
        
        if (!window.confirm(confirmMessage)) {
            return;
        }

        // Elimina tutti i file selezionati
        let deletePromises = filesToDelete.map(file => {
            return new Promise((resolve, reject) => {
                let formData = new FormData();
                formData.append("path", this.state.path.join("/") + "/" + file);
                ajax.ajaxPost("/file_delete.php", formData, resolve, reject);
            });
        });

        Promise.all(deletePromises)
            .then(() => {
                this.setState({ selectedFiles: [] });
                this.downloadFiles();
            })
            .catch((error) => {
                console.error("Errore eliminazione file:", error);
                alert("Errore durante l'eliminazione di alcuni file");
                this.downloadFiles();
            });
    }

    createFolder = () => {
        let name = prompt("Nome cartella")
        this.closeContextMenu()
        if (!name) { return; }

        let formData = new FormData();
        formData.append("path", this.state.path.join("/"))
        formData.append("name", name)
        ajax.ajaxPost("/file_create_folder.php", formData, this.downloadFiles, (error) => {
            console.error("Errore creazione cartella:", error);
            alert("Errore durante la creazione della cartella");
        })
    }

    renameFile = () => {
        let name = prompt("Rinomina file", this.state.contextFileSelected)
        this.closeContextMenu()
        if (!name) { return; }

        let formData = new FormData();
        formData.append("path", this.state.path.join("/"))
        formData.append("name", name)
        formData.append("oldName", this.state.contextFileSelected)
        ajax.ajaxPost("/file_rename.php", formData, this.downloadFiles, (error) => {
            console.error("Errore rinomina file:", error);
            alert("Errore durante la rinomina del file");
        })
    }

    uploadFiles = (files) => {
        let formData = new FormData();

        formData.append("path", this.state.path.join("/"))
        files.map((file, index) => {
            formData.append("file[]", file);
        })

        this.setState({loading:true})
        ajax.ajaxPost("/file_upload.php", formData, this.downloadFiles, (error) => {
            console.error("Errore upload file:", error);
            this.setState({ loading: false });
            alert("Errore durante il caricamento dei file");
        })
    }

    handleFolderUpload = () => {
        this.closeContextMenu();
        // Trigger il click sull'input file nascosto
        if (this.folderInputRef.current) {
            this.folderInputRef.current.click();
        }
    }

    handleFolderInputChange = (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        console.log('=== Folder Upload ===');
        console.log('Total files:', files.length);

        this.setState({ loading: true });

        // Carica tutti i file con la loro struttura
        const formData = new FormData();
        formData.append("path", this.state.path.join("/"));
        
        files.forEach((file, index) => {
            // webkitRelativePath contiene: "NomeCartellaSelezionata/sottocartella/file.txt"
            // Manteniamo TUTTA la struttura incluso il nome della cartella principale
            const relativePath = file.webkitRelativePath;
            
            console.log('File:', file.name);
            console.log('  webkitRelativePath:', file.webkitRelativePath);
            console.log('  relativePath (finale):', relativePath);
            
            // Passa il file e il suo path relativo come parametri separati
            formData.append("file[]", file);
            formData.append("filePath[]", relativePath);
        });

        ajax.ajaxPost("/file_upload.php", formData, 
            () => {
                this.downloadFiles();
                // Reset input
                if (this.folderInputRef.current) {
                    this.folderInputRef.current.value = '';
                }
            }, 
            (error) => {
                console.error("Errore upload cartella:", error);
                this.setState({ loading: false });
                alert("Errore durante il caricamento della cartella");
                // Reset input
                if (this.folderInputRef.current) {
                    this.folderInputRef.current.value = '';
                }
            }
        );
    }


    renderFileSystem = (files) => {
        let arr = []
        let currentIndex = 0;
        
        // Se ci sono risultati di ricerca, mostra quelli invece del contenuto normale
        if (this.state.searchResults !== null) {
            if (this.state.searchResults.length === 0) {
                return (
                    <Grid container>
                        <div style={{ padding: '40px', textAlign: 'center', width: '100%' }}>
                            <Icon style={{ fontSize: 60, color: '#999' }}>search_off</Icon>
                            <MDTypography variant="h6" color="text" style={{ marginTop: 10 }}>
                                Nessun risultato trovato per "{this.state.searchQuery}"
                            </MDTypography>
                        </div>
                    </Grid>
                );
            }

            this.state.searchResults.forEach((result, index) => {
                if (result.isDirectory) {
                    arr.push(this.renderSearchFolder(result, index));
                } else {
                    arr.push(this.renderSearchFile(result, index));
                }
            });
        } else {
            // Comportamento normale: mostra contenuto directory corrente
            if (files.directory) {
                files.directory.map((el) => {
                    arr.push(this.renderFolder(el, currentIndex))
                    currentIndex++;
                })
            }

            if (files.files) {
                files.files.map((el) => {
                    arr.push(this.renderFile(el, currentIndex))
                    currentIndex++;
                })
            }
        }

        return (
            <Grid container>
                {arr}
            </Grid>
        )
    }
    
    renderFolder = (file, index) => {
        const isSelected = this.isSelected(file);
        return (
            <button 
                ref={(el) => this.fileRefs[file] = el}
                onContextMenu={(event) => this.openContextMenu(event, file)}
                className={`${styles.folder} ${isSelected ? styles.selected : ''}`}
                key={"folder-" + index}
                onClick={(event) => this.handleFileClick(file, index, event, true)}
            >
                <img src="./img/file-icons/folder.png" />
                <div className={styles.folderName}>
                    {file}
                </div>
            </button>
        )
    }

    renderSearchFolder = (result, index) => {
        return (
            <button 
                className={styles.folder}
                key={"search-folder-" + index}
                onClick={() => {
                    // Naviga dentro la cartella trovata
                    const pathParts = result.path.split('/');
                    const newPath = [this.props.baseRoute + "/" + this.props.id + this.props.subfolder, ...pathParts];
                    this.setState({ 
                        path: newPath,
                        searchQuery: '',
                        searchResults: null 
                    }, () => {
                        this.downloadFiles();
                    });
                }}
            >
                <img src="./img/file-icons/folder.png" />
                <div className={styles.folderName}>
                    <div style={{ fontSize: '0.85em', fontWeight: 'bold' }}>{result.name}</div>
                    <div style={{ fontSize: '0.7em', color: '#666', marginTop: '2px' }}>{result.path}</div>
                </div>
            </button>
        )
    }

    renderSearchFile = (result, index) => {
        const ext = result.name.split(".").pop();
        return (
            <button
                className={styles.folder}
                key={"search-file-" + index}
                onClick={() => {
                    // Naviga alla cartella contenente il file
                    const pathParts = result.path.split('/');
                    pathParts.pop(); // Rimuovi il nome del file
                    const newPath = [this.props.baseRoute + "/" + this.props.id + this.props.subfolder, ...pathParts];
                    this.setState({ 
                        path: newPath,
                        searchQuery: '',
                        searchResults: null 
                    }, () => {
                        this.downloadFiles();
                    });
                }}
            >
                <img src={"./img/file-icons/" + this.renderFileIcon(ext)} />
                <div className={styles.folderName}>
                    <div style={{ fontSize: '0.85em', fontWeight: 'bold' }}>{result.name}</div>
                    <div style={{ fontSize: '0.7em', color: '#666', marginTop: '2px' }}>{result.path}</div>
                </div>
            </button>
        )
    }

    renderFile = (file, index) => {
        const isSelected = this.isSelected(file);
        return (
            <button
                ref={(el) => this.fileRefs[file] = el}
                onContextMenu={(event) => this.openContextMenu(event, file)}
                className={`${styles.folder} ${isSelected ? styles.selected : ''}`}
                key={"file-" + index}
                onClick={(event) => this.handleFileClick(file, index, event, false)}
            >
                <img src={"./img/file-icons/" + this.renderFileIcon(file.split(".").pop())} />
                <div className={styles.folderName}>
                    {file}
                </div>
            </button>
        )
    }

    renderFileIcon=(ext)=>{
        switch (ext.toUpperCase()) {
            case "PDF": return "pdf.png";

            case "DOC": return "word.png";
            case "DOCX": return "word.png";

            case "MP3": return "music.png";
            case "WAW": return "music.png";

            case "RAR": return "zip.png";
            case "ZIP": return "zip.png";

            case "CSV": return "excel.png";
            case "XML": return "excel.png";
            case "XLS": return "excel.png";
            case "XLSX": return "excel.png";

            case "EXE": return "text.png";

            case "TTF": return "text.png";

            case "PNG": return "image.png";
            case "GIF": return "image.png";
            case "JPEG": return "image.png";
            case "JPG": return "image.png";

            case "TXT": return "text.png";

        }

        return "text.png"
    }
    

    render() {
        return (
            <>
                <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20}}>
                <Breadcrumbs>
                    {this.state.path.map((el, index) => {
                        return (
                            <button className={styles.breadcrumbs} key={"breadcrumbs-" + index} onClick={() => this.goBack(index)}>
                                <MDTypography
                                    textTransform="uppercase"
                                    opacity={(index == this.state.path.length - 1) ? 1 : 0.5}
                                    variant={"button"}
                                    fontWeight={"bold"}
                                >
                                    {(index == 0) ? "Home" : el}
                                </MDTypography>
                            </button>
                        )
                    })}
                </Breadcrumbs>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <MDInput
                        placeholder="Cerca nelle sottocartelle..."
                        value={this.state.searchQuery}
                        onChange={(e) => this.handleSearchChange(e.target.value)}
                        size="small"
                        style={{ width: '250px' }}
                        InputProps={{
                            startAdornment: (
                                <Icon style={{ marginRight: 5, color: '#666' }}>
                                    {this.state.isSearching ? 'hourglass_empty' : 'search'}
                                </Icon>
                            ),
                            endAdornment: this.state.searchQuery ? (
                                <Icon 
                                    style={{ cursor: 'pointer', color: '#666' }}
                                    onClick={() => this.handleSearchChange('')}
                                >
                                    close
                                </Icon>
                            ) : null,
                        }}
                    />
                    {this.state.selectedFiles.length > 0 && (
                        <MDTypography variant="button" color="info">
                            {this.state.selectedFiles.length} {this.state.selectedFiles.length === 1 ? 'elemento' : 'elementi'} selezionato{this.state.selectedFiles.length === 1 ? '' : 'i'}
                        </MDTypography>
                    )}
                    <MDButton color={"info"} onClick={() => this.setState({modalUploadOpen:true})}>
                        <Icon style={{ marginRight: 10 }}>upload</Icon>
                        Carica File
                    </MDButton>
                    <MDButton color={"success"} onClick={() => this.handleFolderUpload()}>
                        <Icon style={{ marginRight: 10 }}>drive_folder_upload</Icon>
                        Carica Cartella
                    </MDButton>
                </div>
                </div>

                <div 
                    ref={this.containerRef}
                    onContextMenu={(event) => this.openContextMenu(event)} 
                    className={styles.filesContainer}
                    onMouseDown={this.handleContainerMouseDown}
                    onMouseMove={this.handleContainerMouseMove}
                    onMouseUp={this.handleContainerMouseUp}
                    onMouseLeave={this.handleContainerMouseUp}
                >
                    {this.state.loading ?
                        <div className={styles.loaderContainer}>
                            <CircularProgress />
                        </div>
                        : null}

                    {this.state.error ? 
                        <div style={{ 
                            padding: '20px', 
                            textAlign: 'center', 
                            color: '#f44336',
                            backgroundColor: '#ffebee',
                            borderRadius: '4px',
                            margin: '20px 0'
                        }}>
                            <Icon style={{ marginRight: '8px', verticalAlign: 'middle' }}>error</Icon>
                            <MDTypography variant="body2" component="span">
                                {this.state.error}
                            </MDTypography>
                            <div style={{ marginTop: '10px' }}>
                                <MDButton 
                                    variant="outlined" 
                                    color="error" 
                                    size="small" 
                                    onClick={() => {
                                        this.setState({ loading: true, error: null });
                                        
                                        // Se errore 500, prima crea la directory con file_create_gara.php
                                        if (this.state.hasError500) {
                                            let formData = new FormData();
                                            formData.append("id", this.props.id);
                                            
                                            ajax.ajaxPost("/file_create_gara.php", formData,
                                                (response) => {
                                                    this.downloadFiles();
                                                },
                                                (error) => {
                                                    this.downloadFiles();
                                                }
                                            );
                                        } else {
                                            this.downloadFiles();
                                        }
                                    }}
                                >
                                    Riprova
                                </MDButton>
                            </div>
                        </div>
                        : null}

                    {!this.state.error && this.renderFileSystem(this.state.files)}

                    {/* Rettangolo di selezione durante drag */}
                    {this.state.isDragging && this.state.dragStart && this.state.dragEnd && (
                        <div
                            className={styles.selectionBox}
                            style={{
                                left: Math.min(this.state.dragStart.x, this.state.dragEnd.x),
                                top: Math.min(this.state.dragStart.y, this.state.dragEnd.y),
                                width: Math.abs(this.state.dragEnd.x - this.state.dragStart.x),
                                height: Math.abs(this.state.dragEnd.y - this.state.dragStart.y)
                            }}
                        />
                    )}

                    <Menu
                        open={this.state.contextMenuVisible}
                        onClose={() => this.closeContextMenu()}
                        anchorReference="anchorPosition"
                        anchorPosition={this.state.contextMenuAnchor}
                    >
                        <MenuItem onClick={() => this.createFolder()}>
                            <ListItemIcon>
                                <Icon fontSize="medium" >create_new_folder</Icon>
                            </ListItemIcon>
                            <ListItemText>
                                <MDTypography variant={"button"}>Nuova Cartella</MDTypography>
                            </ListItemText>
                        </MenuItem>

                        <MenuItem onClick={() => { this.setState({ modalUploadOpen: true });this.closeContextMenu() }}>
                            <ListItemIcon>
                                <Icon fontSize="medium" >cloud_upload</Icon>
                            </ListItemIcon>
                            <ListItemText>
                                <MDTypography variant={"button"}>Carica File</MDTypography>
                            </ListItemText>
                        </MenuItem>

                        {(this.state.contextFileSelected && this.state.selectedFiles.length === 1) ?
                            <MenuItem onClick={() => this.renameFile()}>
                                <ListItemIcon>
                                    <Icon fontSize="medium" >edit</Icon>
                                </ListItemIcon>
                                <ListItemText>
                                    <MDTypography variant={"button"}>Rinomina</MDTypography>
                                </ListItemText>
                            </MenuItem>
                            : null
                        }
                        {(this.state.contextFileSelected || this.state.selectedFiles.length > 0) ?
                            <MenuItem onClick={(e) => {
                                e.stopPropagation();
                                // Usa la cache invece dello state
                                const filesToDelete = this.filesToDeleteCache.length > 0
                                    ? this.filesToDeleteCache
                                    : [this.state.contextFileSelected];
                                this.deleteFile(filesToDelete);
                            }}>
                                <ListItemIcon>
                                    <Icon fontSize="medium" >remove_circle</Icon>
                                </ListItemIcon>
                                <ListItemText>
                                    <MDTypography variant={"button"}>
                                        Elimina{this.state.selectedFiles.length > 1 ? ` (${this.state.selectedFiles.length})` : ''}
                                    </MDTypography>
                                </ListItemText>
                            </MenuItem>
                            : null
                        }
                    </Menu>
                </div>

                {/* Input nascosto per caricamento cartelle */}
                <input
                    ref={this.folderInputRef}
                    type="file"
                    webkitdirectory="true"
                    directory="true"
                    multiple
                    style={{ display: 'none' }}
                    onChange={this.handleFolderInputChange}
                />

                <DropzoneDialog
                    cancelButtonText={"Annulla"}
                    submitButtonText={"Invia"}
                    open={this.state.modalUploadOpen}
                    onClose={() => this.setState({ modalUploadOpen: false })}
                    onSave={(files) => {
                        this.uploadFiles(files)
                        this.setState({ modalUploadOpen: false })
                    }}
                    showPreviews={true}
                    showFileNamesInPreview={true}
                    filesLimit={100}
                    maxFileSize={3000000000}
                />

            </>
        )
    }
}

FileSystem.defaultProps = {
    subfolder: "",
}


export default FileSystem